module.exports = __webpack_public_path__ + "static/media/weekday-evening-games.dcaf010b.png";